// extracted by mini-css-extract-plugin
export var orderDetails = "_r0-2";
export var orderImage = "_r0-1";
export var orderMeta = "_r0-3";
export var orderSummary = "_r0-0";
export var rightArrow = "_r0-4";